import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RewardService {



  constructor(private http: HttpClient) { }

  private tokenObservable$ = new BehaviorSubject<string>("");

  token = this.tokenObservable$.asObservable();
  
  public setTokenReward(token: string = "") {
    this.tokenObservable$.next(token);
  }

}
